
import Component, { mixins } from "vue-class-component";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import { ProxyTableData } from '@/UI/components/Helpers/ProxyTableData';
import { SalaryCalculationsTable } from "@/UI/pages/SalaryСalculations/lib/table";

@Component({
    components: {
        PageTitle,
        BaseDataForm,
    }
})

export default class CosmetologCard extends mixins (ProxyTableData, SalaryCalculationsTable) {

    async created() {
        this.formReady = true
    }

}
